import React from 'react';
import { CustomMaterialTable } from '../../../common/CustomMaterialTable';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {DialogBoxMedium} from '../../../common/dialog.medium';
import { formatName } from '../../../common/common';
import { CustomizedSnackbars } from '../../../common/snackbars';
import { CustomDatePicker } from '../../../common/CustomDatePicker';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';

const DialogComponent = (p) => {
    const {FormProps:props} = p;
        return (
            <form className="form-fullwidth" onSubmit={props.OnSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <FormControl variant="standard">
                            <InputLabel 
                                shrink
                                id ="demo-simple-select-placeholder-label-label"
                                htmlFor = "fmla_type_id"
                                required
                                error = {props.Errors.fmla_type_id && true}>
                                FMLA Event Type
                            </InputLabel>
                            <Select
		                        value = {props.FormFields.fmla_type_id ? props.FormFields.fmla_type_id :''}
                                onChange = {props.HandleOnChange}
                                displayEmpty
                                inputProps = {{
                                    name: 'fmla_type_id',
                                    id: 'fmla_type_id',
                                }}>
                                <MenuItem value=""><em>Select</em></MenuItem>
                                {typeof(props.FmlaEventTypes) !== undefined && props.FmlaEventTypes.map((fmla, i) =>
                                    <MenuItem value={fmla.id} key={'fmla-'+i}>{fmla.title}</MenuItem>
                                )}
                            </Select>
		                    <small className='error'>{props.Errors.fmla_type_id}</small>
                        </ FormControl>
                    </Grid>
			        <Grid item xs={12} md={6}>
                        <FormControl>
                            <CustomDatePicker
                                id = "start_date"
                                name = "start_date"
                                selectedDate={props.FormFields.start_date}
                                handleDateChange={props.HandleDateChange}
                                required={true}
                                label={'Start Date'}
                            />
		                    <small className='error'>{props.Errors.start_date}</small>
                        </FormControl>
                    </Grid>
		            <Grid item xs={12} md={6}>
                        <FormControl>
                            <CustomDatePicker
                                id = "end_date"
                                name = "end_date"
                                selectedDate={props.FormFields.end_date}
                                handleDateChange={props.HandleDateChange}
                                minDate ={ props.FormFields.start_date}
                                required={true}
                                label={'End Date'}
                            />
				        <small className='error'>{props.Errors.end_date }</small>
                        </ FormControl>
                    </Grid>
		            <Grid item xs={12} md={12}>
                        <FormControl>
                             <TextareaAutosize
                                id="notes"
                                name="notes"
                                label="Notes"
                                type="text"
                                required
                                placeholder="Notes"
                                minRows={5}
                                value={props.FormFields.notes ? props.FormFields.notes : '' }
                                onChange={props.HandleOnChange}
                                multiline
                                />
                             <small className='error'>{props.Errors.notes }</small>
                            <Alert severity="info" style={{'marginTop': '1rem'}}>  The notes entered will be visible to staff </Alert>
                        </ FormControl>
                    </Grid>
		        </Grid>
            </form>
        )
};

export const FmlaEventConfigComponent = (props) => {
    const columns = [
        { title: 'FMLA Type', field: 'fmla_type_name'},
        { title: 'Start Date', field: 'start_date'},
   	    { title: 'End Date', field: 'end_date'},
	    { title: 'Notes', field: 'notes'},
	];
    return (
        <React.Fragment>
            <div className={'mtable-basic'}>
	            <CustomMaterialTable
                    title="FMLA events"
                    columns={columns}
                    data={props.StaffFmlaEventList}
                    options={{
                        actionsColumnIndex: -1,
                        search: false,
                        paging:false,
                    }}      
                    actions={[
                        {   
                            icon: 'add',
                            tooltip: 'Add FMLA Event',
                            isFreeAction: true,
                            onClick: (event, newData) => { 
                                props.OnAddFmlaEvent();
                            },
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Edit',
                            onClick: (event, rowData) => {
                                props.HandleUpdate(rowData.id);
                            },
                        },

                    ]}
                    editable={{
                        onRowDelete: rowData =>
                            new Promise((resolve, reject) => {
                                setTimeout(() => {{
                                    props.OnDelete(rowData);
                                }resolve()
                                }, 500)
                        }),
                    }}
		        />
            </div>
            <DialogBoxMedium
                Open={props.Open}
                Cancel={props.Close}
                Content={<DialogComponent FormProps={props}/>}
                OnSubmit={props.SaveStaffFmlaEvent}
                Title= {props.IsEdit ? 'Edit FMLA Event' : 'Add FMLA Event'}
            />
            <CustomizedSnackbars
               open={props.Snackbar}
               variant={props.Variant}
               message={props.Message}
               handleClose={props.SnackbarClose}
	        />
        </React.Fragment>
    )
};
